<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-9">
        <span class="cat__core__title">
          <strong>Edit Document</strong>
        </span>
      </div>
      <div class="col-lg-3">
        <span style="float: right">
          <a (click)="back()">
            <button class="btn btn-sm btn-default btn-back" type="button">
              <i class="fa fa-chevron-circle-left"></i>&nbsp;Back
            </button></a>
        </span>
      </div>
    </div>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-lg-12">
        <div class="margin-bottom-50">
          <form>
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-2">
                    <label class="form-control-label">Sr. No</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="issueSeries" [(ngModel)]="serialNo" name="srNo" class="form-control" readonly
                        required="required">
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label class="form-control-label">Document Name</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <input id="docName" [(ngModel)]="docName" class="form-control" name="docName"
                        (keyup)="checkDocNameOnKeyup()" (keydown)="noBlankSpaceAtStart($event)" required="required">
                      <span *ngIf="isDocNameBlank" style="color: red;">Document Name is required</span>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <button id="saveDocument" type="button" class="btn btn-sm btn-primary" style="float:right;"
                      (click)="updateDocumentName()" [disabled]="isDocNameBlank || disabledOnclick">
                      <i class="fa fa-save"></i>&nbsp;Update</button>
                  </div>

                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-lg-9">
        <span class="cat__core__title">
          <strong>Data Entry Fields ({{srNo}}) </strong>
        </span>
      </div>
      <!-- <div class="col-lg-3">
        <span style="float: right">
          <a [routerLink]="['/ncd/document/generation/mster/setup']">
        <button class="btn btn-sm btn-default btn-back" type="button">
          <i class="fa fa-chevron-circle-left"></i>Back
        </button></a>
      </span>
      </div> -->
    </div>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-lg-12">
        <div class="margin-bottom-50">
          <form>
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-control-label h4-text" for="l0">SR. NO.
                    </label>
                  </div>
                  <div class="col-lg-5">
                    <label class="form-control-label h4-text" for="l0">Data Entry Field Name
                    </label>
                  </div>
                  <div class="col-lg-5">
                    <label class="form-control-label h4-text" for="l0">
                      Data Entry Rights
                    </label>
                  </div>
                </div>
                <div class="row" *ngFor="let name of fieldNames.filedName; let i = index;">
                  <div class="col-lg-2">
                    <label class="form-control-label" for="l0">{{i + 1}}
                    </label>
                  </div>
                  <div class="col-lg-5">
                    <label class="form-control-label" for="l0"> {{name?.name}}
                    </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group">
                      <!-- <ng-select placeholder="Select User" class="form-control m-b-10 p-8" [multiple]=true
                        [ngModelOptions]="{standalone: true}" (selected)="addUser($event, name, 'Active')"
                        [(ngModel)]="selectedUser[name?.ngField]" (deselected)="addUser($event, name, 'none')"
                        [options]="userList" style="padding: 0px; text-align:left;"> 
                      </ng-select> -->
                      <ng-select placeholder="Select User" class="form-control m-b-10 p-8" [multiple]="true"
                        [ngModel]="selectedUser[name?.ngField]" [ngModelOptions]="{standalone: true}"
                        [items]="userList" bindLabel="label" bindValue="value"
                        (ngModelChange)="addUser($event, name)" (remove)="onDeSelect($event, name)">
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="card">
  <div class="card-header">
    <span style="float:right">
      <button class="btn btn-sm btn-primary mb-2" type="button" data-toggle="modal" data-target="#docUploadDialog"
        (click)="initiateDocumentUpload()" *ngIf="showUploadTemplateBtn">
        <i class="fa fa-plus"></i>&nbsp;Upload Template File</button>
      <button class="btn btn-sm btn-primary mb-2" type="button" (click)="downloadTemplateFile()"
        *ngIf="showUploadTemplateBtn && uploadedTemplateMasterDocId != null">
        <i class="fa fa-download"></i>&nbsp;Download Template File</button>
      <button class="btn btn-sm btn-primary mb-2" type="button" data-toggle="modal" data-target="#editMasterDocDialog"
        (click)="resetPopUp()">
        <i class="fa fa-plus"></i>&nbsp;Add New Word File</button>
    </span>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive" style="width: -webkit-fill-available !important;">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="subDocTable"
              style="cursor: pointer;width: -webkit-fill-available !important;">
              <thead>
                <tr>
                  <th style="display: none">Document Order</th>
                  <th style="display: none">ID</th>
                  <th>Sr. No</th>
                  <th>Document Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let subDoc of subDocuments">
                  <td style="display: none">{{subDoc.documentOrder}}</td>
                  <td style="display: none">{{subDoc._id}}</td>
                  <td class="reOrderRow">{{subDoc.SrNo}}</td>
                  <td class="reOrderRow">{{subDoc.DocumentName}}</td>
                  <td>
                    <button type="button" class="btn-sm btn btn-warning"
                      (click)="getSubDocumentsBySubDocumentId(subDoc._id)">
                      <span class="fa fa-pencil"></span>
                    </button>
                    <button type="button" class="btn-sm btn btn-danger" data-toggle="modal" data-target="#confirmation"
                      (click)="showDeleteConfirmationPopUp(subDoc._id)">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button id="btnDocSaveOrder" type="button" class="btn btn-sm btn-primary" (click)="documentsSaveOrder()"
        [disabled]="disabledOnclick">
        <i class="fa fa-save"></i>&nbsp;Save Order</button>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="editMasterDocDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form [formGroup]="addWordDocForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Add New Word File</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Sr. No.</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input [formControl]="addWordDocForm.controls['SrNo']" class="form-control"
                    (keydown)="noBlankSpaceAtStart($event)" required="required">
                  <div
                    *ngIf="addWordDocForm.controls['SrNo'].hasError('required') && addWordDocForm.controls['SrNo'].touched"
                    class="form-control-error-custom">
                    Sr. No. is required
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Document Name
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input [formControl]="addWordDocForm.controls['DocumentName']" class="form-control"
                    (keydown)="noBlankSpaceAtStart($event)" required="required">
                  <div
                    *ngIf="addWordDocForm.controls['DocumentName'].hasError('required') && addWordDocForm.controls['DocumentName'].touched"
                    class="form-control-error-custom">
                    Document Name is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Data Entry Rights
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <!-- <ng-select placeholder="Select User" class="form-control m-b-10 p-8"
                    [formControl]="addWordDocForm.controls['AccessRights']" [multiple]=true [options]="userList"
                    style="padding: 0px; text-align:left;">
                  </ng-select> -->
                  <ng-select [items]="userList" placeholder="Select User" class="form-control m-b-10 p-8"
                    bindLabel="label" bindValue="value" [multiple]="true" style="padding: 0px; text-align:left;" [ngModelOptions]="{standalone: true}"
                    [formControl]="addWordDocForm.controls['AccessRights']">
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary"
              [disabled]="!addWordDocForm.valid || disabledOnclick" (click)="addSubDocuments()"
              *ngIf="addBtn">Save</button>
            <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary"
              [disabled]="!addWordDocForm.valid || disabledOnclick" (click)="updateSubDocuments()"
              *ngIf="!addBtn">Update</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="entryFieldDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form [formGroup]="addDataEntryFieldForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Add Data Entry Field</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label">Sr. No.</label>
                <span _ngcontent-c2="" style="color: red;">*</span>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input [formControl]="addDataEntryFieldForm.controls['SrNo']" class="form-control"
                    (keydown)="noBlankSpaceAtStart($event)" required="required">
                  <div
                    *ngIf="addDataEntryFieldForm.controls['SrNo'].hasError('required') && addDataEntryFieldForm.controls['SrNo'].touched"
                    class="form-control-error-custom">
                    Sr. No. is required
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Data Entry Field Name
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input [formControl]="addDataEntryFieldForm.controls['FieldName']" class="form-control"
                    (keydown)="noBlankSpaceAtStart($event)" required="required">
                  <div
                    *ngIf="addDataEntryFieldForm.controls['FieldName'].hasError('required') && addDataEntryFieldForm.controls['FieldName'].touched"
                    class="form-control-error-custom">
                    Field Name is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary"
              [disabled]="!addDataEntryFieldForm.valid || disabledOnclick" (click)="addDataEntryFields()">Save</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete this document?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteSubDoc()">
            <i class="fa fa-check"></i>&nbsp;Yes</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="docUploadDialog" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fa fa-upload"></i>
            <span id="documentUploadTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">

              <div class="col-md-4">
                <label class="col-form-label" for="l5">
                  <span>Template
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </span>
                </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <input type="file" class='form-control fileUpload' accept=".docx"
                    (change)="docsChangeEvent($event)" />
                  <!-- <span *ngIf="typeHasError" style="color: red">
                    Only DOCX Type File is allowed to upload.
                  </span> -->
                  <span style="color: red" *ngIf="!fileExtension">Only DOCX Type File is allowed to upload.</span>

                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">

          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" [disabled]="!fileExtension"
            (click)="uploadDocFile()">
            <i class="fa fa-save"></i>&nbsp;Upload</button>

          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;Close</button>

        </div>
      </div>
    </div>
  </div>

</section>